module.exports = __webpack_public_path__ + "static/media/fatima-avatar.306f7345.svg";